import React, { useEffect, useState } from "react";
import useTheme from "../../../hooks/useTheme";

import { Modal } from "semantic-ui-react"
import { closeModal, openModal } from "../../../redux/Modals/ModalActions";
import { useResponsive } from "../../UI/ResponsiveContext";
import { connect, useSelector } from "react-redux";
import { fetchAndSetCurrentJob } from "../../../redux/Jobs/jobsActions";
import { showToast } from "../../../redux/Snackbar/SnackbarActions";
import CandidateDetailPage from "./Components/CandidateDetailPage";

const mapStateToProps = (state) => {
    return {
        jobs: state.jobs,
    };
};


const CandidateDetailView = ({ closeModal, jobs, candidateData: selectedCandidateData, jobId: passedJobId, fetchAndSetCurrentJob, showToast, openModal }) => {
    const theme = useTheme();
    const { isMobile } = useResponsive();

    const { appliedJobs } = useSelector((state) => state.auth);

    const dashboardJobs = jobs.dashboardJobs ?? [];
    const currentJob = jobs.currentJob;

    // Use passedJobId (from chat context) to look up candidateData from appliedJobs
    // when selectedCandidateData wasn't available at modal open time.
    const resolvedCandidateData = selectedCandidateData ?? appliedJobs?.find(
        (app) => (app.jobDetails?.jobId ?? app.jobId) === passedJobId
    );

    const [newCandidateData, setNewCandidateData] = useState(resolvedCandidateData);

    useEffect(() => {
        if (!newCandidateData && resolvedCandidateData) {
            setNewCandidateData(resolvedCandidateData);
        }
    }, [resolvedCandidateData, newCandidateData]);

    const candidateJobId = newCandidateData?.jobDetails?.jobId ?? newCandidateData?.jobId ?? passedJobId;

    const existingAppliedJobData = dashboardJobs.find((job) => job.jobId === candidateJobId);
    const currentAppliedJobData = currentJob?.data?.jobId === candidateJobId ? currentJob?.data : existingAppliedJobData;


    useEffect(() => {
        if (!currentAppliedJobData && candidateJobId) {
            fetchAndSetCurrentJob(candidateJobId, false)
        }
    }, [currentAppliedJobData, candidateJobId])



    return (<Modal
        basic
        key={candidateJobId}
        centered={true}
        open={true}
        closeOnEscape={true}
        closeOnDimmerClick={true}
        onClose={() => {
            closeModal();
        }}
        style={{
            margin: "0",
            padding: "0",
            top: "0",
            borderRadius: isMobile ? "0px" : theme.radius.default,
            height: isMobile && "100%",
            width: isMobile ? "100%" : "60%",
            marginTop: isMobile ? "0px" : theme.spacing.contentPadding,
            marginBottom: isMobile ? "0px" : theme.spacing.contentPaddingBig,
            backgroundColor: theme.colors.white,
            transform: "none",
        }}>

        <CandidateDetailPage
            candidateData={newCandidateData}
            closeModal={closeModal}
            job={currentAppliedJobData}
            showToast={showToast}
            onCandidateChange={(candidateData) => {
                setNewCandidateData(candidateData);
            }}
        />

    </Modal>)
}



export default connect(mapStateToProps, {
    fetchAndSetCurrentJob,
    closeModal,
    showToast,
    openModal,
})(CandidateDetailView);

export const MODAL_CANDIDATE_DETAIL = "CandidateDetailView";


